import React, { Component } from "react";
import Fade from "react-reveal";

class About extends Component {
  render() {
    // اگر داده‌ای دریافت نشده بود، کامپوننت را رندر نکن
    if (!this.props.data) return null;

    // اطلاعات شخصی و مسیرها
    const profilepic = "images/" + this.props.data.image; // عکس پروفایل
    const bio1 = this.props.data.bio1;
    const bio2 = this.props.data.bio2;
    const bio3 = this.props.data.bio3;
    const name = this.props.data.name;
    const city = this.props.data.address.city;
    const country = this.props.data.address.country;
    const phone = this.props.data.phone;
    const email = this.props.data.email;

    // لینک رزومه‌ها / پروژه‌ها
    const resumedownload = this.props.data.resumedownload; // رزومه فارسی

    return (
      <section id="about">
        {/* افکت Fade برای ورود محتوای About */}
        <Fade duration={1000}>
          <div className="row">
            {/* ستون عکس پروفایل */}
            <div className="three columns">
              <img className="profile-pic" src={profilepic} alt="Profile-Pic" />
            </div>

            {/* ستون اطلاعات شخصی */}
            <div className="nine columns main-col">
              <div className="side-by-side-per">
                <h2>About Me</h2>
              </div>

              {/* بیوگرافی */}
              <p>
                <span>{bio1}</span>
                <br />
                <span>{bio2}</span>
                <br />
                <span>{bio3}</span>
                <br />
              </p>

              {/* دکمه دانلود رزومه فارسی */}
              <div className="see-cvs-btn-cv">
                <a
                  rel="noreferrer"
                  href={resumedownload}
                  className="buttons-about"
                  target="_blank"
                >
                  <span>رزومه فارسی</span> &nbsp; &nbsp;
                  <i className="fa fa-file-text"></i>
                </a>
              </div>

              {/* لینک نقشه ایران */}
              <p>
                Where is IRAN located? click &#10147;{" "}
                <a
                  className="green-iran"
                  rel="noreferrer"
                  href="https://upload.wikimedia.org/wikipedia/commons/a/a8/Iran_%28orthographic_projection%29.svg"
                  target="_blank"
                >
                  IRAN
                </a>
              </p>

              {/* جزئیات تماس */}
              <div className="row">
                <div className="columns contact-details">
                  <h2 style={{ color: "#fff" }}>Contact Details</h2>
                  <p className="address">
                    <span>
                      <i className="fa fa-user-circle contact-i"></i> {name}
                    </span>
                    <br />
                    <span>
                      <i className="fa fa-map-marker contact-i"></i> {city},{" "}
                      {country}
                    </span>
                    <br />
                    <span>
                      <i className="fa fa-mobile contact-i"></i> {phone}
                    </span>
                    <br />
                    <span>
                      <i className="fa fa-envelope contact-i"></i> {email}
                    </span>
                  </p>

                  <hr className="hr-default" />

                  {/* بخش حمایت مالی */}
                  <div className="finance" style={{ textAlign: "center" }}>
                    <p style={{ marginBottom: "2px", marginTop: "-15px" }}>
                      Your support (a coffee or a book) means a lot.
                    </p>
                    <span className="see-cvs-btn">
                      <a
                        rel="noreferrer"
                        href="https://www.buymeacoffee.com/tyazdani72"
                        target="_blank"
                      >
                        <img
                          src="https://cdn.buymeacoffee.com/buttons/v2/default-red.png"
                          alt="Buy Me A book"
                          width="150"
                        />
                      </a>
                      <br />
                      <a href="http://www.coffeete.ir/tyazdaniit">
                        <img
                          className="coffee"
                          src="http://www.coffeete.ir/images/buttons/lemonchiffon.png"
                          alt="coffeete"
                        />
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default About;
